import { api } from './api'; // your configured axios instance
import { Ride } from '../types/Ride';

// GET paginated list of rides (for admin table)
export const getRides = (params?: any) => api.get('/admin/rides', { params });

// GET full details for one ride by ID
export const getRide = (rideId: number) =>
    api.get<Ride>(`/admin/ride/${rideId}`);

// You can add updateRide etc if needed as per your existing driverService/userService
